"use strict";

export function initInScope ($scope) {

    $scope.find('.js-show-all-content__content').each(function () {

        if($(this).height() > 210){
            $(this).closest('.js-show-all-content').addClass('show-all-content__max-height');
        }

    });

    $scope.find('.js-show-all-content__btn').on('click', function (e) {

        let $showAllContent = $(this).closest('.js-show-all-content');

        $showAllContent.toggleClass('show');

    });

}
